import { Navigate, Outlet } from 'react-router-dom'
import { UseKeycloakService } from 'core/packages/KeycloakProvider'
import { ROUTE_PATHS } from 'core/constants/routePath'
import { isDebugEmailAllowed } from 'iadocs/const/debugAccess'

export const DebugGuard = () => {
  const kc = UseKeycloakService()

  if (!isDebugEmailAllowed(kc.getEmail())) {
    return <Navigate to={ROUTE_PATHS.IADOCS} replace />
  }

  return <Outlet />
}
